module.exports = __webpack_public_path__ + "static/img/texaspoke_en.28163ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/texaspoke_en.png
// module id = 0gk+
// module chunks = 1